import { theme } from '@features/executive-report/domain/theme';

export const colorByIndex = (index: number) =>
  index % 2 === 0 ? theme.colors.lightBlue : theme.colors.inmarketGreen;
